














import { defineComponent, type PropType } from "vue-demi";
import GGGroup from "./GGGroup/GGGroup.vue";
import GGReviewCard from "./GGReviewCard/GGReviewCard.vue";
import GGRowSlider from "./GGRowSlider/GGRowSlider.vue";
import type { PageData } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGReviewSection",
  components: {
    GGGroup,
    GGReviewCard,
    GGRowSlider,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
});
